import * as tslib_1 from "tslib";
// Core components
import { OnInit } from "@angular/core";
// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';
// Custom components
var FileDownloaderTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FileDownloaderTypeComponent, _super);
    /**
     * Class constructor
     */
    function FileDownloaderTypeComponent(configService, translateService, toastrService) {
        var _this = _super.call(this) || this;
        _this.configService = configService;
        _this.translateService = translateService;
        _this.toastrService = toastrService;
        _this.files = [];
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    FileDownloaderTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        var docs = [];
        if (this.model && this.model.length) {
            docs = this.model;
        }
        else if (this.model && this.model.documents && this.model.documents.length) {
            docs = this.model.documents;
        }
        else {
            this.toastrService.error("Nessun file presente!");
            return;
        }
        if (docs.length) {
            docs.forEach(function (file) {
                var path = "";
                var url = "";
                // piattaforma 1
                if (file.path.substr(0, 33) === "https://app.archedi.it/documents/") {
                    // https://api.archedi.it/uploads/properties/5f8d4974a2a02e1a9488b883/documents/41969250-12f0-11eb-af37-877a6b43bbd3.pdf
                    // url = file.path;
                    url = "https://api.archedi.it/uploads/properties/" + _this.model.propertyId + "/documents/" + file.filename;
                }
                else {
                    path = file.path.replace(/src[\\\/]assets/g, 'public');
                    path = path.replace(/^\/+/, '');
                    url = _this.configService.apiHost + "/" + path;
                }
                var newFile = tslib_1.__assign({}, file, { url: url });
                _this.files.push(newFile);
            });
        }
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    FileDownloaderTypeComponent.prototype.onDownload = function (file) {
        FileSaver.saveAs(file.url, file.originalName);
    };
    return FileDownloaderTypeComponent;
}(FieldType));
export { FileDownloaderTypeComponent };
